import React from "react";
import styles from "../Styles/NotFound.module.css";

function NotFound() {
  return (
    <div className={styles.notfound}>
      <h1>404 Page Not Found</h1>
    </div>
  );
}

export default NotFound;
